import { useCallback } from 'react'
import { useRouter } from 'next/router'

/**
 * Reloads the current page's server data (getServerSideProps) without a full page reload.
 * Call it after a change is saved so every number on screen reflects the database.
 */
export const useRefresh = () => {
    const router = useRouter()

    return useCallback(async () => {
        await router.replace(router.asPath, undefined, { scroll: false })
    }, [router])
}
